import {Injectable} from '@angular/core';
import {BaseOPEService} from "./BaseOPEService";
import {GetTimeChartMetricsCB} from "../../ope/telemetry/GetTimeChartMetricsCB";
import {DownloadTimeChartMetricsCB} from "../../ope/telemetry/DownloadTimeChartMetricsCB";

@Injectable({
  providedIn: 'root'
})
export class TelemetryOpeService extends BaseOPEService {

  public getTimeChartMetrics(cb: GetTimeChartMetricsCB) {
    return this.execOPE(cb);
  }

  public downloadTimeChartMetrics(cb: DownloadTimeChartMetricsCB) {
    return this.execOPE(cb);
  }
}
